export default "__VITE_ASSET__5daad8dd__"